import React from 'react';
import { format } from 'date-fns/format';
import { MonthCaptionProps } from 'react-day-picker';
import styled from 'styled-components';
import { ResourceHeading2 } from 'components/theme/Typography/ResourceTypography';
import { useGlobalDateLocale } from 'context/DateLocaleContext';

const CalendarMonthCaption = ({
  calendarMonth,
  ...props
}: MonthCaptionProps) => {
  const { locale } = useGlobalDateLocale();
  const currentYear = new Date().getFullYear();
  const calendarYear = calendarMonth.date.getFullYear();
  const shouldShowYear = calendarYear !== currentYear;

  const formatString = shouldShowYear ? 'MMMM yyyy' : 'MMMM';

  return (
    <MonthCaptionWrapper aria-atomic="true" aria-live="polite" {...props}>
      <StyledMonthCaption
        className="experiences__date-picker-month-caption"
        fontSize="21px"
      >
        {format(calendarMonth.date, formatString, { locale })}
      </StyledMonthCaption>
    </MonthCaptionWrapper>
  );
};

const MonthCaptionWrapper = styled.div`
  height: var(--rdp-nav-height);
  display: grid;
  place-items: center;
`;

const StyledMonthCaption = styled(ResourceHeading2)`
  text-align: center;
  color: var(--way-palette-black-100);
  line-height: 24px;
`;

export default CalendarMonthCaption;
